import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Manager, Target, Popper } from 'react-popper';
import { defaultMenuRenderer } from 'react-select';
import BaseSelect from "../Select/BaseSelect";
import Portal from "../../core/Portal";
var BOTTOM_MENU_OFFSET = 40; // inner block height should be 1px shorter then parent block
// this 1px is parent's border width which was hidden

var MAX_MENU_HEIGHT = 297;

var PortalSelect =
/** @class */
function (_super) {
  tslib_1.__extends(PortalSelect, _super);

  function PortalSelect() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.setNode = function (node) {
      _this.node = node;

      var wrapper = _this.getWrapper();

      _this.poperTarget.ref(wrapper);
    };

    _this.setTarget = function (_a) {
      var targetProps = _a.targetProps;
      _this.poperTarget = targetProps;
      return null;
    };

    _this.getWrapper = function () {
      var node = _this.node || {};
      var select = node.select || node;
      return select.wrapper;
    };

    _this.menuRenderer = function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      } // will be called if node exist


      var menuRenderer = _this.props.menuRenderer;
      return _this.renderPortal(menuRenderer.apply(void 0, tslib_1.__spread(args)));
    };

    _this.noResultsRenderer = function (noResultsText) {
      return _this.renderPortal(React.createElement("div", {
        className: "Select-noresults"
      }, React.createElement("div", {
        className: "Select-noresults-text"
      }, noResultsText)));
    };

    _this.renderPortal = function (content) {
      var _a = _this.props,
          portalSelectMenuZIndex = _a.portalSelectMenuZIndex,
          portalMenuWrapperClassName = _a.portalMenuWrapperClassName;

      var wrapper = _this.getWrapper();

      var _b = wrapper ? wrapper.getBoundingClientRect() : {
        width: 0,
        bottom: 0,
        top: 0
      },
          width = _b.width,
          bottom = _b.bottom,
          top = _b.top;

      var heightToBottom = typeof window === 'undefined' ? 0 : window.innerHeight - bottom - BOTTOM_MENU_OFFSET;
      var maxHeight = MAX_MENU_HEIGHT;

      if (heightToBottom < MAX_MENU_HEIGHT) {
        var heightToTop = top - BOTTOM_MENU_OFFSET;
        maxHeight = Math.min(Math.max(heightToBottom, heightToTop), MAX_MENU_HEIGHT);
      }

      return React.createElement(Portal, null, React.createElement(Popper, {
        style: {
          zIndex: portalSelectMenuZIndex
        },
        modifiers: {
          preventOverflow: {
            enabled: true,
            escapeWithReference: true,
            boundariesElement: 'viewport'
          }
        }
      }, React.createElement("div", {
        style: {
          width: width
        },
        className: cx('nx-select', portalMenuWrapperClassName)
      }, React.createElement("div", {
        className: "Select-menu-outer portal"
      }, React.createElement("div", {
        className: "Select-menu",
        style: {
          maxHeight: maxHeight
        }
      }, content)))));
    };

    return _this;
  }

  PortalSelect.prototype.render = function () {
    var _a = this.props,
        className = _a.className,
        managerTag = _a.managerTag,
        other = tslib_1.__rest(_a, ["className", "managerTag"]);

    var finalClassName = cx(className, 'in-portal');
    return React.createElement(Manager, {
      tag: managerTag
    }, React.createElement(Target, null, this.setTarget), React.createElement(BaseSelect, tslib_1.__assign({}, other, {
      className: finalClassName,
      instanceRef: this.setNode,
      menuRenderer: this.menuRenderer,
      noResultsRenderer: this.noResultsRenderer
    })));
  };

  PortalSelect.propTypes = {
    menuRenderer: PropTypes.func,
    portalMenuWrapperClassName: PropTypes.string,
    className: PropTypes.string,
    portalSelectMenuZIndex: PropTypes.number,
    managerTag: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
  };
  PortalSelect.defaultProps = {
    menuRenderer: defaultMenuRenderer,
    portalSelectMenuZIndex: 9999,
    managerTag: false
  };
  return PortalSelect;
}(Component);

export default PortalSelect;

try {
  // @ts-ignore
  PortalSelect.__docgenInfo = {
    "description": "",
    "displayName": "PortalSelect",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}